import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDepMobileIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	width: 24,
	height: 24,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M0 0h24v24H0z",
		fill: "none"
	}), /* @__PURE__ */ _jsx("path", { d: "M11 6H3v12h8l4 4h6V6h-6l-4 4zm-4 9V9h2v6H7zm10 0h-2V9h2v6zm-6 0H9V9h2v6z" })]
});
export { SvgDepMobileIcon as ReactComponent };
